import { render, staticRenderFns } from "./PdfWidget.vue?vue&type=template&id=05260762&scoped=true&"
import script from "./PdfWidget.vue?vue&type=script&lang=js&"
export * from "./PdfWidget.vue?vue&type=script&lang=js&"
import style0 from "./PdfWidget.vue?vue&type=style&index=0&id=05260762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05260762",
  null
  
)

export default component.exports